<template>
  <f7-page>
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title>
        <div>LINE Pay: 付款未完成</div>
      </f7-nav-title>
    </f7-navbar>
    <f7-block class="content">
      <div>LINE Pay 付款<span style="color: red; font-size: 24px;">未完成</span></div>
      <div v-if="order">訂單代號：{{ order.nickname }}</div>
      <div>請至點餐紀錄查看訂單並重新付款</div>
      <f7-button raised fill @click="backToMenu()">回到菜單</f7-button>
    </f7-block>
  </f7-page>
</template>

<script>
import { storeClient } from '@/service/apiClients'

export default {
  data () {
    return {
      order: null
    }
  },
  async created () {
    try {
      const { data: order } = await storeClient.get(`/stores/${this.storeIdPathParam}/orders/${this.publicIdPathParam}/client`)
      this.order = order
    } catch (e) {
      this.backToMenu()
    }
  },
  methods: {
    backToMenu () {
      this.$f7router.navigate(`/stores/${this.storeIdPathParam}/menu`, {
        reloadCurrent: true
      })
    }
  },
  props: {
    storeIdPathParam: String,
    publicIdPathParam: String
  }
}
</script>

<style lang="scss" scoped>
.content {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.content * {
  font-size: 18px;
  margin: 10px;
}
</style>
